module.exports = __webpack_public_path__ + "assets/b8eb0059ebd6a152e677e74e65d20e00.png";